export default __webpack_public_path__ + "static/media/daytona.549b19dc.png";